import React from 'react';
import { LinkedinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const navLinks = [{
    name: 'My Story',
    href: '#/my-story'
  }, {
    name: 'Services',
    href: '#/services'
  }, {
    name: 'Results',
    href: '#/results'
  }, {
    name: 'Resources',
    href: '#/resources'
  }, {
    name: 'Contact',
    href: '#/contact'
  }];
  return <footer className="w-full bg-brand-light-gray py-12 px-4 sm:px-6 lg:px-8" data-id="element-76" data-mp="3ufjvpz20zku4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-77" data-mp="37o5ytxdtvcu">
        <div className="text-brand-gray-light text-sm" data-id="element-78" data-mp="3ldu4ouc22nwv">
          © 2026 Break a Pencil Consulting
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-79" data-mp="3qblyxv06am48">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-gray-light hover:text-brand-orange transition-colors text-sm font-medium" data-id="element-80" data-mp="2a1jl9ej7c453">
              {link.name}
            </a>)}
        </div>

        <div className="flex items-center space-x-4" data-id="element-81" data-mp="3gbqx8d534h9u">
          <a href="mailto:michael@breakapencil.com" className="text-brand-gray-light hover:text-brand-orange transition-colors" aria-label="Email Michael" data-id="element-82" data-mp="3v7ggi3ivygav">
            <MailIcon className="w-5 h-5" data-id="element-83" data-mp="82ienymgqkhh" />
          </a>
          <a href="https://www.linkedin.com/in/mhirsch/" target="_blank" rel="noopener noreferrer" className="text-brand-gray-light hover:text-brand-orange transition-colors" aria-label="LinkedIn Profile" data-id="element-84" data-mp="81785r1muymo">
            <LinkedinIcon className="w-5 h-5" data-id="element-85" data-mp="cv1qor5i57k6" />
          </a>
        </div>
      </div>
    </footer>;
}